import { validateResponse } from "../../response.js";
import { sendFileResponse } from "./specs.js";
const sendFile = async (apiUrl, { scope, referenceId, uploadedFile, uploadToken, alias }, init) => {
  const formData = new FormData();
  formData.append("scope", scope);
  formData.append("referenceId", referenceId);
  formData.append("uploadedFile", uploadedFile, alias || uploadedFile.name);
  return validateResponse(
    sendFileResponse,
    await fetch(`${apiUrl}/upload/file`, {
      method: "POST",
      body: formData,
      headers: {
        "x-upload-token": uploadToken
      },
      ...init
    })
  );
};
export {
  sendFile
};
//# sourceMappingURL=send-file.js.map
